/**
 * @fileoverview Curriculum Service for Arc Mosaico
 * @description Service to fetch curriculum items (skills and standards) by grade
 */
import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico'
import { ISkillsStandards } from 'pages/NewProject/components/ProjectSkillsStandards/interfaces'

/**
 * Response from /api/arc_mosaico/curriculum_items endpoint
 * Can return either the full object or an empty array if grade is blank
 */
interface CurriculumItemsResponse {
  by_cycle?: boolean
  byCycle?: boolean  // camelCase variant (axios transform)
  curriculum_items?: {
    subjects?: any[]  // Standards - Arcmosaico
    axes?: any[]      // Skills - Arcmosaico
  }
  curriculumItems?: {  // camelCase variant (axios transform)
    subjects?: any[]
    axes?: any[]
  }
}

/**
 * Fetch curriculum items (skills and standards) by grade ID
 * Uses /api/arc_mosaico/curriculum_items?grade_id=X
 *
 * @param gradeId - The grade ID to fetch curriculum for
 * @returns ISkillsStandards - Formatted curriculum data
 */
export const getCurriculumItemsByGrade = async (gradeId: string): Promise<ISkillsStandards> => {
  const url = ARC_MOSAICO_ENDPOINTS.curriculum.items(gradeId)
  console.log('[CurriculumService] Fetching curriculum for grade:', gradeId, 'URL:', url)

  const response = await api.get<CurriculumItemsResponse>(url)

  console.log('[CurriculumService] Response:', response)
  console.log('[CurriculumService] Response data:', response?.data)

  const data = response?.data

  // Handle empty/null response or error response
  if (!data || Array.isArray(data) || typeof data !== 'object') {
    console.warn('[CurriculumService] Empty or invalid response, returning empty curriculum')
    return {
      byCycle: false,
      groupSchoolTerm: { name: '' },
      totalStudents: 0,
      selectedItems: { contents: [], specificSkills: [] },
      curriculumItems: { subjects: [], axes: [] },
    }
  }

  // Handle both snake_case and camelCase responses (axios camelizeKeys interceptor)
  const byCycle = data.byCycle ?? data.by_cycle ?? false
  const curriculumItems = data.curriculumItems || data.curriculum_items || {}

  console.log('[CurriculumService] curriculumItems:', curriculumItems)

  const subjects = curriculumItems.subjects || []
  const axes = curriculumItems.axes || []

  console.log('[CurriculumService] subjects count:', subjects.length, 'axes count:', axes.length)

  // Transform response to match ISkillsStandards format
  return {
    byCycle,
    groupSchoolTerm: {
      name: '',
    },
    totalStudents: 0,
    selectedItems: {
      contents: [],
      specificSkills: [],
    },
    curriculumItems: {
      subjects,
      axes,
    },
  }
}
